import { FC, useState } from "react";
import classNames from "classnames";
import { useSetAtom } from "jotai";

import { Button, EButtonVariant } from "components/Button/Button";
import { DialogContent } from "components/DialogContent/DialogContent";
import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { Option } from "components/Select/Select";
import RadioButton from "components/Radio/Radio";
import { MediumText } from "components/MediumText/MediumText";

import { setModalCloseAtom } from "../../atoms/modalAtom/modalAtom";

import styles from "./styles.module.css";

export type SelectModalProps = {
  title: string;
  onSelectClick?: (val?: Option) => void;
  buttonText?: string;
  atomToOpen?: any;
  setAtomClose?: any;
  options?: Option[];
};

export const SelectModal: FC<SelectModalProps> = ({
  title,
  onSelectClick,
  buttonText = "Выбрать",
  setAtomClose = setModalCloseAtom,
  options,
}): JSX.Element => {
  const closeModal = useSetAtom(setAtomClose);
  const [selectedVal, setSelectedVal] = useState<Option>();

  const handleClick = () => {
    if (typeof onSelectClick === "function") {
      onSelectClick(selectedVal);
    } else {
      closeModal();
    }
  };

  return (
    <DialogContent
      className={classNames(styles.dialog, "flex items-center flex-col" as any)}
      setAtomClose={setAtomClose}
    >
      <MediumText
        size={16}
        className={classNames(
          styles.title,
          "mb-6 flex justify-center items-center text-center" as any
        )}
      >
        {title}
        <HorizontalSpace size={30} />
      </MediumText>
      <VerticalSpace size={12} />
      <div className={styles.ratioList}>
        {options?.length ? (
          options.map((option) => (
            <RadioButton
              key={option.value}
              id={option.value}
              text={option.label}
              name={option.label}
              onChange={() => {
                setSelectedVal(option);
              }}
              checked={selectedVal?.value === option.value}
              value={selectedVal?.value === option.value ? 1 : 0}
            />
          ))
        ) : (
          <p>Пусто.</p>
        )}
      </div>
      <VerticalSpace size={36} />
      <div className="flex flex-row">
        <Button
          disabled={!selectedVal}
          onClick={handleClick}
          variant={EButtonVariant.SECONDARY}
        >
          {buttonText}
        </Button>
        <HorizontalSpace size={10} />
        <Button onClick={closeModal} variant={EButtonVariant.TERTIARY}>
          Отмена
        </Button>
      </div>
    </DialogContent>
  );
};
